module.exports = __webpack_public_path__ + "static/media/sinister_type_hail.dc68175c.svg";